<template lang="pug">
	nav#sfc-mobile-menu
		.menu-container
			.h-content
				.first-item-new-menu
					hamburger-icon.hamburger-icon(v-if="!isOpenMobile" @click="showMenuMobile()")
					close-icon.close-icon(v-else @click="showMenuMobile()")

					.container-mobile(:class="{'open-mobile': isOpenMobile}")
						ul.menu-mobile
							li.item.main-option-mobile(v-for="menu of menuJson" v-if="menu.title != 'Login'" :key="'mobile-' + menu.id" :class="{'is-selected': menu.clicked}" v-bind:style='{"display" : (isActive ? "flex" : "none")}' @click.self="showSubelementMobile(menu); trackAction('Menu Navigation Click', {'title': `${menu.title}`})")
								mobile-search-icon.mobile-search-icon(v-if="menu.title == 'Search'")
								a.title-submenu(:href="menu.url")
									| {{menu.title}}

								span.arrow(:class="[{'right': !back}, {'left': back}]")

								.sub-menu-mobile(v-if="menu.children.length > 0 && menu.title != 'Search'")
									.menu-wrap-mobile
										.item.menu-subtitle-mobile
											.wrap-option-mobile(v-for="submenu of menu.children" :key="'mobile-' + submenu.id")
												span.menu-heading
													| {{submenu.title}}

												ul.sub-menu2-mobile(v-if="submenu.children")
													li.item.menu-option-mobile(v-for="child of submenu.children" v-if="child.show_logged_out" :key="'mobile-' + child.id" :class="{'subscription-link': child.title == 'Subscribe'}")
														a(v-if="child.id == '21'" :href="child.url" :class="{'active': currentUrl == trimmedUrl(child.url)}" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
															| {{child.title}} {{currentYear}}
														a(v-else :href="child.url" :class="{'active': currentUrl == trimmedUrl(child.url)}" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
															| {{child.title}}
													no-ssr(v-for="child of submenu.children" v-if="$store.state.userIsLoggedIn && !child.show_logged_out" :key="'mobile-' + child.id")
														li.menu-option-mobile.no-ssrr
															a(:href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
																| {{child.title}}
							no-ssr
								li.item.main-option-mobile.no-ssrr(v-for="menu of menuJson" v-if="menu.title == 'Login'" :key="'mobile-' + menu.id" :class="{'is-selected': menu.clicked}" v-bind:style='{"display" : (isActive ? "flex" : "none")}' @click="showSubelementMobile(menu)")
									mobile-login-icon.mobile-login-icon(v-if="!back")
									a.title-submenu(v-if="!$store.state.userIsLoggedIn" @click="openLogin")
										| Login
									a.title-submenu(v-else href="/manage_account/")
										| Account

									span.arrow(:class="[{'right': !back}, {'left': back}]")

									.sub-menu-mobile
										.menu-wrap-mobile
											.item.menu-subtitle-mobile
												//.wrap-option-mobile
													span(v-if="!$store.state.userIsLoggedIn")
														a.menu-heading(@click="openLogin")
															| Advisor
												//.wrap-option-mobile
													span(v-if="!$store.state.userIsLoggedIn")
														a.menu-heading(href="/savings-center/login")
															| Personal
												.wrap-option-mobile
													span(v-if="$store.state.userIsLoggedIn")
														a.menu-heading(href="/manage_account/")
															| Account
												.wrap-option-mobile
													span(v-if="$store.state.userIsLoggedIn")
														a.menu-heading(:href="logoutUrl")
															| Logout

					.blocker(@click="showMenuMobile()" :class="{'open-mobile': isOpenMobile}")

				.second-item-new-menu
					a(href="/")
						sfc-logo-mobile.sfc-logo-mobile

</template>

<style lang="stylus">
	.menu-savings-center-spinner
		display: inline-block
</style>

<style lang="stylus" scoped>
	@import '~assets/css/redesign-v1/variables.styl'

	#sfc-mobile-menu
		width: 100%
		background-color: blue-primary
		color: body-font-color-black
		display: flex
		@media(min-width: 992px)
			display: none
		.menu-container
			max-width: 1176px
			width: 100%
			margin: 0 auto
			padding: 0 16px
			.h-content
				align-items: center
				width: 100%
				display: flex
				display: -webkit-flex
				flex-wrap: wrap
				-webkit-flex-wrap: wrap
				align-content: center
				height: 56px!important

				.first-item-new-menu
				.second-item-new-menu
					display: flex
					align-items: center

				.first-item-new-menu
					.hamburger-icon
					.close-icon
						cursor: pointer
						width: auto
						height: 18px

					.container-mobile
						display: none
						&.open-mobile
							display: flex
						ul.menu-mobile
							position: fixed
							z-index: 998
							margin-top: 28px
							background-color: #fff
							left: 0
							width: 375px
							padding: 0 16px 24px
							height: 100%
							box-shadow(16px 0px 16px -16px rgba(0, 0, 0, 0.15))
							overflow: auto
							@media(max-width: 575px)
								width: 100%
							li.main-option-mobile
								display: flex
								padding: 24px 0px
								border-bottom: 1px solid gray-disabled
								list-style: none
								line-height: normal
								cursor: pointer
								a
									text-decoration: none !important
									font-size: body-font-size-md
									text-transform: uppercase
									color: body-font-color-black
								.arrow
									position: absolute
									width: 10px
									height: 10px
									border-top: 1px solid body-font-color-black
									border-right: 1px solid body-font-color-black
									align-self: center

								.right
									transform: rotate(45deg)
									-ms-filter "progid:DXImageTransform.Microsoft.Matrix(SizingMethod='auto expand', M11=0.7071067811865476, M12=-0.7071067811865475, M21=0.7071067811865475, M22=0.7071067811865476)"
									right: 20px
								.left
									transform: rotate(225deg)
									-ms-filter: "progid:DXImageTransform.Microsoft.Matrix(SizingMethod='auto expand', M11=-0.7071067811865476, M12=0.7071067811865475, M21=-0.7071067811865475, M22=-0.7071067811865476)"
									top: 24px
									left: 20px
									margin-top: 6px

								.mobile-search-icon
								.mobile-login-icon
									margin-right: 8px
									align-self: center

								.sub-menu-mobile
									display: none
									.menu-wrap-mobile
											.item.menu-subtitle-mobile
												.wrap-option-mobile
													&:last-of-type
														margin-bottom: 52px
								&.is-selected
									display: flex !important
									flex-direction: column
									border: none
									.title-submenu
										text-align: center !important
										align-self: center
										padding-bottom: 24px
									.sub-menu-mobile
										display: flex
										border-top: 1px solid gray-disabled
										.menu-heading
											margin-top: 24px
											display: inline-block
											font-size: 18px
											font-weight: bold
											line-height: normal
											cursor: default
										a.menu-heading
											text-transform: none
											cursor: pointer
											&:hover
												color: blue-primary !important
												text-decoration: underline !important
										ul.sub-menu2-mobile
											margin: 0
											height: auto
											display: flex
											flex-flow: column
											width: 100%
											padding: 0
											li.menu-option-mobile
												list-style: none
												margin-top: 16px
												a
													font-size: body-font-size-md
													line-height: normal
													color: body-font-color-black !important
													text-transform: none
													font-weight: normal
													&.active
													&:hover
														color: blue-primary !important
														text-decoration: underline !important

							.button
								margin: 34px auto 60px
								>>>.sfc-simple-button
									width: 200px
									margin: 0 auto

					.blocker
						display: none
						position: fixed
						top: 56px
						left: 375px
						bottom: 0
						right: 0
						content: ' '
						background: rgba(0,0,0,.3)
						z-index: 100
						&.open-mobile
							display: block

				.second-item-new-menu
					flex-grow: 2
					justify-content: center
					svg.sfc-logo-mobile
						width: auto
						height: 28px
						@media(max-width: 280px)
							display: none

</style>

<script>
	import HamburgerIcon from '@/common/components/icons/redesign-v1/hamburger-icon'
	import SfcLogoMobile from '@/common/components/icons/redesign-v1/sfc-logo-mobile'
	import CloseIcon from '@/common/components/icons/redesign-v1/close-icon'
	import SearchIcon from '@/common/components/icons/redesign-v1/search-icon'
	import MobileSearchIcon from '@/common/components/icons/redesign-v1/mobile-search-icon'
	import MobileLoginIcon from '@/common/components/icons/redesign-v1/mobile-login-icon'
	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import MenuJSON from '@/menu-footer.json'

	export default {

	components:{
		HamburgerIcon,
		SfcLogoMobile,
		CloseIcon,
		SearchIcon,
		MobileSearchIcon,
		MobileLoginIcon,
		SfcSimpleButton,
		MenuJSON
	},


	data() {
		return {
			currentYear: '',
			isSelected: false,
			isOpenMobile: false,
			isActive: true,
			back: false,
			loadingSavingsCenterUser: false,
			savingsCenterFlow: false,
			logoutUrl: '/logout/',
			menuJson: MenuJSON['menu'],
			fadeAway: false,
			lastScroll: 0
		}
	},

	methods: {

		async openSavingsCenter(){
			let nextPageUrl = false

			nextPageUrl = await this.nextStep()

			if(nextPageUrl){
				window.location.href = nextPageUrl
			}else{
				setTimeout(()=>{
					this.$sfcModal.open("sfc-onboarding-modal-v3-2", {savingsCenterFlow: true})
				},0)
			}
		},

		async nextStep(){
			const token = this.$cookies.get("sfc_primary")
			let collegeSavingsUser = undefined

			if (token){
				if (this.$store.state.collegeSavingsUserOnboarding  && this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]){
					return "/savings-center/" + this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
				}
			}
			else{
				return false
			}

			const query = `
				query{
					no_graphql_cache()
					college_savings_user_v3(sfc_token: "${token}"){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`

			this.loading = true
			try {
				const result = await this.$httpService.graphql(query)
				collegeSavingsUser = result.data.college_savings_user_v3
			} catch (e) {
				collegeSavingsUser = undefined
			}
			this.loading = false

			if(!collegeSavingsUser)	return false

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

			return "/savings-center/" + collegeSavingsUser.next_step_v3
		},

		trackAction(eventDescription, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, "Navigation", "2", additionalInformation)
		},

		showMenuMobile(){
			if(!this.isOpenMobile){
				this.isOpenMobile = true
			}else{
				this.isOpenMobile = false
				this.isSelected = false
				this.isActive = true
				for(const m of this.menuJson){
					m.clicked = false
				}
				this.back = false
			}

			if (this.isOpenMobile) {
				document.querySelector('html').classList.add("noscroll")
				document.body.classList.add("noscroll")
			}else{
				document.querySelector('html').classList.remove("noscroll")
				document.body.classList.remove("noscroll")
				document.body.scrollTop = this.lastScroll
			}
		},

		handleOnScroll(e){
			if(this.isOpenMobile){
				e.stopPropagation()
				e.preventDefault()
				return false
			}
			const currentScroll = document.documentElement.scrollTop || document.body.scrollTop

			const elem = document.querySelector('#sfc-mobile-menu')

			// Get height of navbar and current Y position
			const max = Math.max( elem.scrollHeight, elem.offsetHeight, elem.clientHeight) + elem.getBoundingClientRect().top

			// Check if scroll positions changed
			if(currentScroll != this.lastScroll){
				// Fade away the menu if
				// Menu is not open
				// User is scrolling down
				// And scroll position is past by the initial height of the menu
				this.fadeAway = currentScroll > 0 && currentScroll >= max && this.lastScroll < currentScroll && this.open == false && this.autohide == true
			}
			this.lastScroll = currentScroll
		},

		showSubelementMobile(menu){
			if(menu.clicked == false){
				if (((menu.title != "Search")&&(menu.title != "Login")) || ((menu.title == "Login")&&(this.$store.state.userIsLoggedIn))){
					this.isSelected = true
					menu.clicked = true
					this.isActive =!this.isActive
					for(const m of this.menuJson){
						if(m.title != menu.title){
							m.clicked = false
						}
					}
					this.back = true
				}else{
					if (menu.title == "Search"){
						window.location.href = '/search';
					}else{
						if((menu.title == "Login")&&(!this.$store.state.userIsLoggedIn)){
							this.openLogin()
						}
					}
				}
			}else{
				this.isSelected = false
				menu.clicked = false
				this.isActive =!this.isActive
				this.back = false
			}
		},

		openLogin(){
			window.location.href = '/login'
		},

		obModalShow(){
			this.savingsCenterFlow = false
		},
		trimmedUrl(url){
			return url.replace(/\/$/, "")
		}

	},

	computed: {
		currentUrl(){
			return this.$route.path.replace(/\/$/, "")
		}
	},

	mounted() {
		window.addEventListener('scroll', this.handleOnScroll, { passive: false });
		document.body.addEventListener('touchmove', this.preventScroll, { passive: false });

		this.logoutUrl = `/logout/?return_url=${window.location.href}`

		this.currentYear = new Date().getFullYear()
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.handleOnScroll, { passive: false });
		document.body.removeEventListener('touchmove', this.preventScroll, { passive: false });
	}
}
</script>
